import type { ItemType } from "types"
import { useLocale } from "hooks"
import { getPDPUrl } from "utils/getPDPUrl"
import { useMemo } from "react"

export const usePDPUrl = (item: ItemType): string => {
  const locale = useLocale()
  const pdpUrl = useMemo(
    () => getPDPUrl(item?.variant ?? null, locale),
    [locale, item]
  )
  return pdpUrl
}
